import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AnimatedSticky } from 'site-modules/shared/components/animated-sticky/animated-sticky';
import { AnchorNavContentDropdown } from './anchor-nav-content-dropdown';

import './anchor-nav-sticky.scss';
import './anchor-nav-sticky-dropdown.scss';

/**
 * To work properly with offsets anchors should be <ScrollElement id={anchorId} />
 * Example: client/site-modules/editorial/components/top-rated/vehicle-section/vehicle-section.jsx
 */
export function AnchorNavStickyDropdown({
  className,
  navList,
  title,
  stickyTitle,
  linkTrackingId,
  hasSeparator,
  stickyClassName,
  navWrapperClassName,
  titleClassName,
  containerClassName,
  anchorNavContentClassName,
  stickyAnchorNavContentClassName,
  listClassName,
  stickyListClassName,
  creativeId,
  hideSticky,
  isMobile,
}) {
  const [optionHash, setOptionHash] = useState('');

  if (!navList) {
    return null;
  }

  const stickyFragmentTitle = stickyTitle || title;

  return (
    <div className={classnames('anchor-nav-sticky', className)} data-tracking-parent={creativeId}>
      <div className={containerClassName}>
        <AnimatedSticky
          identifierClass="anchor-nav-sticky"
          stickyClassName={classnames('nav-wrapper d-flex align-items-center', stickyClassName)}
          className={classnames('nav-wrapper d-flex align-items-center', navWrapperClassName)}
          hideSticky={hideSticky}
          stickyFragment={
            <AnchorNavContentDropdown
              navList={navList}
              linkTrackingId={linkTrackingId}
              className={stickyAnchorNavContentClassName || anchorNavContentClassName}
              listClassName={stickyListClassName || listClassName}
              labelTitleClassName={classnames('nav-title mb-0', titleClassName)}
              optionHash={optionHash}
              setOptionHash={setOptionHash}
              labelTitle={stickyFragmentTitle}
              isMobile={isMobile}
            />
          }
        >
          <AnchorNavContentDropdown
            navList={navList}
            linkTrackingId={linkTrackingId}
            className={anchorNavContentClassName}
            listClassName={listClassName}
            labelTitleClassName={classnames('nav-title mb-0', titleClassName)}
            optionHash={optionHash}
            setOptionHash={setOptionHash}
            labelTitle={title}
            isMobile={isMobile}
          />
        </AnimatedSticky>
        {hasSeparator && <hr className="w-100 mt-0 border-gray" />}
      </div>
    </div>
  );
}

AnchorNavStickyDropdown.propTypes = {
  navList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      hash: PropTypes.string,
    })
  ),
  title: PropTypes.string,
  stickyTitle: PropTypes.string,
  className: PropTypes.string,
  linkTrackingId: PropTypes.string,
  hasSeparator: PropTypes.bool,
  stickyClassName: PropTypes.string,
  navWrapperClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  anchorNavContentClassName: PropTypes.string,
  stickyAnchorNavContentClassName: PropTypes.string,
  listClassName: PropTypes.string,
  stickyListClassName: PropTypes.string,
  creativeId: PropTypes.string,
  hideSticky: PropTypes.bool,
  isMobile: PropTypes.bool,
};

AnchorNavStickyDropdown.defaultProps = {
  navList: null,
  title: 'Jump to:',
  stickyTitle: null,
  className: null,
  linkTrackingId: 'view_content',
  hasSeparator: true,
  stickyClassName: null,
  navWrapperClassName: '',
  titleClassName: 'heading-5 pe-1',
  containerClassName: 'container',
  anchorNavContentClassName: undefined,
  stickyAnchorNavContentClassName: undefined,
  listClassName: undefined,
  stickyListClassName: undefined,
  creativeId: undefined,
  hideSticky: false,
  isMobile: false,
};
